<template>
  <sliderBarDialogShell
    ref="sliderbar"
    :dialog-show="dialogShow"
    :dialog-title="title"
    @close="beforeClose"
    @submit="confirm"
    class="editStatrgyManagerDialog"
  >
    <statrgy-manager-form
      v-if="dialogShow"
      ref="outform"
      @submit="submit"
    ></statrgy-manager-form>
  </sliderBarDialogShell>
</template>

<script>
import statrgyManagerForm from "@/components/sys/strategyManager/statrgyManagerForm";
import {updateStrategy} from "@/api/sys/statrgyManager/statrgyManager";

export default {
  name: "editStatrgyManagerDialog",
  components: {
    statrgyManagerForm,
  },
  props: {
    formData:{
      type: Object,
      default(){
        return {}
      }
    },
    dialogShow:{
      type: Boolean,
      default: false,
    }
  },
  watch:{
    dialogShow(val){
      if(val && this.formData.id){
        setTimeout(()=> {
          this.$refs.outform.assigen(this.formData);
        },200);
      }
    }
  },
  data() {
    return {
      title: '编辑策略'
    }
  },
  methods: {
    beforeClose() {
      this.$emit('close');
      this.$refs.outform.selfClear();
    },
    cancel() {
      this.beforeClose();
    },
    confirm() {
      // todo
      this.$refs.outform.selfValidate();
    },
    submit(form) {
      let params = {
        ...form
      }
      updateStrategy(params).then((data) => {
        if(data && data.code===200){
          this.$message({
            message: '编辑成功',
            type: 'success',
          });
          this.$refs.outform.selfClear();
          this.$emit('edit-success');
        }else{
          this.$message({
            message: data.msg,
            type: 'error'
          });
        }
      }).catch((err) => {
        // this.$message.error(err.msg);
      })
    }
  },
}
</script>

<style>
@media screen and (min-width: 768px) {
  .editStatrgyManagerDialog.sidebar-dialog .vs-sidebar {
    width: 800px;
  }
}
</style>
